import { render, staticRenderFns } from "./OrganismReport.vue?vue&type=template&id=4a2b3b00&scoped=true&"
import script from "./OrganismReport.vue?vue&type=script&lang=js&"
export * from "./OrganismReport.vue?vue&type=script&lang=js&"
import style0 from "./OrganismReport.vue?vue&type=style&index=0&id=4a2b3b00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2b3b00",
  null
  
)

export default component.exports